// Entry point for LPdI Pro app – bootstrap loads config & Sentry, then the app
import {
	runBootstrap,
} from '@src/bootstrap';

runBootstrap({
	pathPrefix: 'webapp',
}, () => import('@src/app.lpdipro.tsx'));
